<template>
	<ModalFormCard class="modal-default wide">
		<template #title>Phone call</template>

		<Input
			name="search"
			label="Search"
			placeholder="Phone numbers, contact name and addresses"
			v-model:value="value"
			groupClass="!bg-grey text-15"
			@keyup="
				() => {
					$help.delay(search, 800)
				}
			"
		/>

		<div class="overflow-hidden">
			<div class="lg:max-h-[600px] lg:overflow-scroll">
				<table class="w-full text-left border-collapse" v-if="data != null">
					<thead class="text-grey-900 hidden lg:table-header-group">
						<tr>
							<!-- <th class="text-13 font-normal sticky p-0 top-0 z-10 overflow-hidden">
								<p class="block w-full border-b border-grey-500 pt-4 pb-2 bg-white">Lead</p>
							</th> -->
							<th class="text-13 font-normal sticky p-0 top-0 z-10 overflow-hidden">
								<p class="block w-full border-b border-grey-500 pt-4 pb-2 bg-white">Contact</p>
							</th>
							<th class="text-13 font-normal sticky p-0 top-0 z-10 overflow-hidden">
								<p class="block w-full border-b border-grey-500 pt-4 pb-2 bg-white">Current deal</p>
							</th>
							<th class="text-13 font-normal sticky p-0 top-0 z-10 overflow-hidden">
								<p class="block w-full border-b border-grey-500 pt-4 pb-2 bg-white">&nbsp;</p>
							</th>
						</tr>
					</thead>

					<CallSearchRow v-for="(r, i) in data" :key="i" :r="r" :i="i" @close="$emit('close')" />
				</table>
			</div>
		</div>
	</ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import CallSearchRow from '~/components/customer/blocks/call-search-row.vue'
import Contact from '~/models/contact.js'

export default {
	mixins: [Modal],

	data() {
		return {
			value: '',
			data: null,
		}
	},

	methods: {
		search() {
			if (this.value.length < 2) {
				this.data = null
				return
			}

			this.$axios
				.post('/actions/make-call-search', {
					search: this.value,
				})
				.then((res) => {
					this.data = Contact.fill(res, {
						$help: this.$help,
					})
				})
		},
	},

	components: {
		CallSearchRow,
	},
}
</script>
